import SideMenuComponent from './SideMenuComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = ({
  login: { isLoggedIn },
  browser: {
    greaterThan: { large }
  }
}) => ({
  isLoggedIn,
  large
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

// Create higher-order component which feeds in specified props.
const SideMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SideMenuComponent);

export default SideMenuContainer;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/SideMenuContainer.js